import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/Services/EstimationService/EstimationStoreService.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import { createEvent, createStore, merge } from 'effector';
import * as api from '@gmini/sm-api-sdk/lib/EstimationApi';
import { clone } from 'ramda';
export function createEstimationStoreService(_ref) {
  var updatedEvent = _ref.updatedEvent;
  var resetCurrent = createEvent({
    name: "resetCurrent",
    sid: "a5slt8"
  });
  var currentEstimation$ = createStore(null, {
    name: "currentEstimation$",
    sid: "glytn2"
  }).reset(resetCurrent);
  currentEstimation$.on(merge([api.Estimation.getMostRecent.defaultContext.doneData, api.Estimation.fetch.defaultContext.doneData, api.Estimation.ImportEstimation.defaultContext.doneData], {
    sid: "ej3ane"
  }), function (_, data) {
    var calculations = data.calculations.map(function (r) {
      return r.id;
    });
    return _objectSpread(_objectSpread({}, data), {}, {
      calculations: calculations
    });
  }).on(merge([updatedEvent.filter({
    fn: api.Estimation.is
  })], {
    sid: "f0opmy"
  }), function (prev, next) {
    if (prev && prev.id === next.id) {
      var calculations = next.calculations.map(function (r) {
        return r.id;
      });
      return _objectSpread(_objectSpread({}, next), {}, {
        calculations: calculations
      });
    }

    return prev;
  }).on(api.Estimation.changeStatus.doneData, function (state, result) {
    var _next$estimationPubli;

    var next = clone(state);
    next === null || next === void 0 ? void 0 : (_next$estimationPubli = next.estimationPublishedVersions) === null || _next$estimationPubli === void 0 ? void 0 : _next$estimationPubli.push(result);
    return next;
  });
  var estimationStatus$ = createStore(null, {
    name: "estimationStatus$",
    sid: "28ae6p"
  }).on(api.Estimation.start.defaultContext.done, function (_, _ref2) {
    var _ref2$params = _ref2.params,
        estimationId = _ref2$params.estimationId,
        estimationVersion = _ref2$params.estimationVersion;
    return _defineProperty({}, buildEstimationStatusKey({
      estimationId: estimationId,
      estimationVersion: estimationVersion
    }), 'Started');
  }).on(api.Estimation.fetchStatus.defaultContext.done, function (_, _ref4) {
    var _ref4$result = _ref4.result,
        id = _ref4$result.id,
        version = _ref4$result.version,
        status = _ref4$result.status;
    return _defineProperty({}, buildEstimationStatusKey({
      estimationId: id,
      estimationVersion: version
    }), status);
  });
  return {
    currentEstimation$: currentEstimation$,
    resetCurrent: resetCurrent,
    estimationStatus$: estimationStatus$
  };
}
export function buildEstimationStatusKey(_ref6) {
  var estimationId = _ref6.estimationId,
      estimationVersion = _ref6.estimationVersion;
  return "".concat(estimationId, ":").concat(estimationVersion);
}